import { render } from "./App.vue?vue&type=template&id=25cded88"
const script = {}

import "./App.vue?vue&type=style&index=0&id=25cded88&lang=scss"

import exportComponent from "E:\\TeamCity\\buildAgent\\work\\44e3aa492d05d81f\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__